/**
 * @Author: wuyang
 * @Date: 2024/1/25
 * @Description: ""
 */

import { SocketIOInstance } from '@/helper/request/socketIOInstance'

export const getSocketIOInstance = () => {
	if (!SocketIOInstance.instance) {
		SocketIOInstance.instance = new SocketIOInstance({})
	}
	return SocketIOInstance.instance
}
